import natalia from '../images/natalia.jpeg'
import lana from '../images/lana.jpeg'
import natali from '../images/natali.jpg'
import natali_new from '../images/natali_new.jpg'

function CoordinatorsPage() {
    return (
        <div id="coordinators" className='coordinator_page'>
            <h1 className="page_title">Создатели ретрита</h1>
            <div className="coordinator_section">
                <div className="coordinator_card">
                    <img src={natalia} alt="Наталия" className="coordinator_image" />
                    <h2>Наталья</h2>
                    <p>Инструктор Polestar Pilates</p>
                    <p>Проводник гвоздестояния</p>
                </div>
                <div className="coordinator_card">
                    <img src={lana} alt="Лана" className="coordinator_image" />
                    <h2>Лана</h2>
                    <p>Консультант по здоровому питанию</p>
                    <p>Beauty-специалист</p>
                    <p>Шеф-повар</p>
                </div>
                <div className="coordinator_card">
                    <img src={natali_new} alt="Наталья" className="coordinator_image" />
                    <h2>Наталья</h2>
                    <p>Организатор</p>
                    <p>Vocal coach</p>
                </div>
            </div>
            <div className="quote_section">
                <blockquote>
                    <ol className="quote_ol">
                            Команда «Перезагрузка» с радостью приглашает вас на загородный пилатес-ретрит — пространство отдыха, восстановления и наполнения энергией. Мы создали для вас день, в котором гармонично соединяются движение, осознанность, вкусная еда и глубокое расслабление на природе.
                        <p>Что вас ждёт:</p>

                        <ul className="quote_ul">Два занятия по пилатесу:</ul>
                        <li className="quote_li">
                           Мягкая практика для всего тела: выравнивание осанки, дыхание, контроль движений<br />
                        </li>

                        <li className="quote_li">
                            Пилатес с оборудованием (кольца, роллы, мячи, массажные мячики) — акцент на глубокие мышцы, руки, бёдра, внутреннюю работу и осознанное движение.<br />
                        </li>

                        <ol className="quote_ol quote_ol_added">
                            <ul className="quote_ul">
                               Дыхательные практики и женские аффирмации на берегу озера — мягкие паузы между активностями для восстановления, настройки и внутреннего наполнения.<br />
                            </ul>

                            <ul className="quote_ul">
                                Индивидуальная практика стояния на гвоздях с каждым участником — как путь к внутренней силе и ясности.<br />
                            </ul>

                            <ul className="quote_ul">
                                Дыхательные практики и женские аффирмации на берегу озера — мягкие паузы между активностями для восстановления, настройки и внутреннего наполнения.<br />
                            </ul>
                        </ol>



                        <ol className="quote_ol quote_ol_added">
                            <ul className="quote_ul">Шведский стол-фуршет с веганскими блюдами:</ul>
                            <li className="quote_li">
                                Свежие салаты;<br />
                            </li>

                            <li className="quote_li">
                                Маффины с авокадо<br />
                            </li>

                            <li className="quote_li">
                                Блинчики из кабачков<br />
                            </li>

                            <li className="quote_li">
                                Крем-суп из тыквы с фисташками<br />
                            </li>

                            <li className="quote_li">
                                Фрукты, соки и ароматный чай<br />
                            </li>


                            <ul className="quote_ul">
                                Завершение дня — сауна и купание в ухоженном частном озере.<br />
                            </ul>

                            <ul className="quote_ul">
                                Сауна и погружение в озеро будут доступны в течение 3 часов.<br />
                            </ul>
                        </ol>
                    </ol>
                    Мы создаём для вас пространство гармонии, перезагрузки и вдохновения. <br />
                    С любовью,  <br />
                    Команда «Перезагрузка»
                     </blockquote>
            </div>
        </div>
    );
}

export default CoordinatorsPage;